var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-watch-button a-button is-sm is-block",class:_vm.watchId ? "is-active is-main" : "is-inactive is-muted",attrs:{"id":"watch-button"},on:{"click":_vm.buttonClick}},[_vm._v(_vm._s(_vm.watchLabel))])
}
var staticRenderFns = []

export { render, staticRenderFns }